import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "address",
    "type",
    "authorizationCode",
    "customsOffice",
    "editLink",
    "shortcut",
  ];
  static values = { url: String };

  connect() {
    $(this.addressTarget).on("select2:select select2:clear", (event) => {
      const addressId = event.type === "select2:clear" ? null : event.target.value;
      if (addressId) {
        this.populate(addressId);
      } else {
        this.clear();
      }
    });
  }

  applyShortcut(event) {
    event.preventDefault();
    const addressId = event.currentTarget.dataset.addressId;
    $(this.addressTarget).val(addressId).trigger("change");
    this.populate(addressId);
  }

  populate(addressId) {
    fetch(`${this.urlValue}?address_id=${addressId}`, {
      headers: { Accept: "application/json" },
    })
      .then((response) => response.json())
      .then((data) => {
        $(this.typeTarget)
          .val(data.customs_location_type || "")
          .trigger("change");
        this.authorizationCodeTarget.value = data.customs_authorization_code || "";
        $(this.customsOfficeTarget)
          .val(data.customs_office_address_id || "")
          .trigger("change");
        this.showEditLink(data.edit_path);
        this.markActiveShortcut(addressId);
      });
  }

  clear() {
    $(this.typeTarget).val("").trigger("change");
    this.authorizationCodeTarget.value = "";
    $(this.customsOfficeTarget).val("").trigger("change");
    this.hideEditLink();
    this.markActiveShortcut(null);
  }

  showEditLink(editPath) {
    if (!this.hasEditLinkTarget || !editPath) {
      this.hideEditLink();
      return;
    }

    this.editLinkTarget.href = editPath;
    this.editLinkTarget.classList.remove("d-none");
  }

  markActiveShortcut(addressId) {
    this.shortcutTargets.forEach((button) => {
      button.classList.toggle("active", button.dataset.addressId === String(addressId));
    });
  }

  hideEditLink() {
    if (!this.hasEditLinkTarget) return;

    this.editLinkTarget.classList.add("d-none");
  }
}
